import { KnmKindCodesEnum } from 'APIPackage/DictionariesModule/enums/KnmKindCodesEnum';

/**
 * Наименования видов КНМ из справочника knm_kind.
 */
export const KNM_KIND_TITLE_BY_CODE: Record<KnmKindCodesEnum, string> = {
  [KnmKindCodesEnum.VK]: 'Выборочный контроль',
  [KnmKindCodesEnum.MZ]: 'Мониторинговая закупка',
  [KnmKindCodesEnum.KZ]: 'Контрольная закупка',
  [KnmKindCodesEnum.IV]: 'Инспекционный визит',
  [KnmKindCodesEnum.DP]: 'Документарная проверка',
  [KnmKindCodesEnum.RO]: 'Рейдовый осмотр',
  [KnmKindCodesEnum.VP]: 'Выездная проверка',
};
